import type { FC } from 'react';

import { AnchorWithTitle } from '@/components/links/anchor';

export const ButtonsPhone: FC = () => {
  return (
    <AnchorWithTitle
      href="tel:8137428178"
      className="link call-style"
    >
      Call (813) 742-8178
    </AnchorWithTitle>
  );
};
